<template>
  <section v-if="periodicPvrs">
    <template>
      <div class="filter search_only">
        <div class="field_left">
          <p class="field">
            <label for="vyhledavani" v-translate>Vyhledávání</label>
            <input class="search clearable" id="vyhledavani" name="vyhledavani" size="30" v-model="searchText"
                   type="text">
            <a @click="clearFilter" id="vyhledavani_delete" class="clearable_btn" :title="$gettext('Vymazat text')"
               :style="{display: (this.searchText ? 'inline' : 'none')}" v-translate>Vymazat</a>
          </p>
        </div>
        <div class="field_right">
          <div class="remaining-space">
            <div class="progressbar">
              <div class="progressbar__actual" :style="{ 'width': this.usedPercentage + '%' }">
                <div class="progressbar__show" :style="{ 'width': '100%' }"/>
              </div>
            </div>
            <div class="actual-space">{{ usedCountFormattedString }}</div>
          </div>
        </div>
      </div>

      <div class="table_overflow">
        <table class="vypis">
        <thead>
        <tr v-if="filteredPeriodicPvrs.length > 0">
          <th class="no_padding drag_drop"></th>
          <th class="no_padding checkbox"></th>
          <th><strong v-translate>Název</strong></th>
          <th v-translate>Vytvořilo zařízení</th>
          <th><span v-translate>Uživatelské profily</span></th>
          <th v-translate>Počet dní nahrávání zpět za CatchUp</th>
          <th v-translate>Minimální čas začátku nahrávání</th>
          <th v-translate>Kanál nahrávání</th>
          <th v-translate>Datum vytvoření</th>
          <th class="no_padding edit"></th>
        </tr>
        </thead>
        <tbody>
        <PeriodicPvrRow
            v-for="entity in filteredPeriodicPvrs"
            :entity="entity"
            :key="entity.id"
            :isDeletable="isEditable"
            :selectedEntities="selectedEntities"
            @input="select"
            @deletePeriodicPvr="onDeletePeriodicPvr"/>
        <tr v-if="filteredPeriodicPvrs.length === 0">
          <td colspan="8" v-translate>Nebylo nalezeno žádné pravidelné nahrávání.</td>
        </tr>
        </tbody>
      </table>
      </div>
    </template>
    <local-list-action-line
                            :entities="filteredPeriodicPvrs"
                            :selected-entities="selectedEntities"
                            :multiple-action-options="multipleActionOptions"
                            @select-all="toggleSelectAll"
                            @run-multiple-action="executeMultipleAction"
    ></local-list-action-line>
  </section>
</template>

<script>
import PeriodicPvrRow from "./PeriodicPvrRow";
import localTable from "@/components/mixins/local-table"

export default {
  name: "PeriodicPvrs",
  components: {PeriodicPvrRow},
  mixins: [localTable],
  props: {
    periodicPvrs: Array | Object,
    isEditable: Boolean,
  },
  data() {
    return {
      searchText: ""
    };
  },
  methods: {
    clearFilter() {
      this.searchText = "";
    },
    onDeletePeriodicPvr(id) {
      this.$emit('deletePeriodicPvr', id);
    },
    executeMultipleAction(action, activeKey) {
      let actionIds = this.selectedEntities.join();
      switch (action) {
        case 'delete-multi':
          this.onDeletePeriodicPvr(actionIds);
          break;
        default:
          this.runMultipleAction(action, activeKey);
      }
    }
  },
  computed: {
    entities(){
      return Object.values(this.filteredPeriodicPvrs);
    },
    multipleActionOptions() {
      return [
        {value: 'choose', text: this.$gettext('Vyberte akci')},
        {value: 'exportCsv', text: this.$gettext('Exportovat do CSV')},
        {value: 'delete-multi', text: this.$gettext('Smazat')}
      ];
    },
    csvHeaders(){
      return {
        'name': {name: this.$gettext('Název')},
        'device_name': {name: this.$gettext('Vytvořilo zařízení')},
        'profiles': {name: this.$gettext('Uživatelské profily'), callback: (entity) => {return entity.profiles.map(i => i.name).join(', ')}},
        'days_back': {name: this.$gettext('Počet dní nahrávání zpět za CatchUp')},
        'minimal_timestamp': {name: this.$gettext('Minimální čas začátku nahrávání')},
        'channel_names': {name: this.$gettext('Kanál nahrávání'), callback: (entity)=>{return entity.channel_names.join(', ')}},
        'timestamp_created': {name: this.$gettext('Datum vytvoření')}
      }
    },
    filteredPeriodicPvrs() {
      if (!this.searchText) {
        return this.periodicPvrs.periodic_pvrs;
      }

      let searchText = this.searchText.toLowerCase();

      return this.periodicPvrs.periodic_pvrs.filter((periodicPvr) => {
        return periodicPvr.name.toLowerCase().includes(searchText) ||
            periodicPvr.device_name.toLowerCase().includes(searchText);
      });
    },
    usedPercentage(){
      let result = (this.periodicPvrs.total_periodic_pvrs * 100)/this.periodicPvrs.maximum_periodic_pvrs;

      return result > 100 ? 100 : result;
    },
    usedCountFormattedString() {
      return this.$gettextInterpolate(this.$gettext("Využito %{used} z %{total}"), {
        used: this.periodicPvrs.total_periodic_pvrs,
        total: this.periodicPvrs.maximum_periodic_pvrs
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/views/subscribers/periodicPvrs/PeriodicPvrs.vue